<!-- Combined warning/error messages (non-blocking) -->
<!-- Sorted: errors first, then warnings. Each message on its own line. -->
<small
  *ngFor="let warning of getSortedMessages()"
  [ngClass]="{
    'warning-message': warning.severity !== 'error',
    'error-message': warning.severity === 'error'
  }"
>
  <span class="message-text">
    <!-- Warning: red "*" (matching the sheet-selector legend), black words.
         Non-blocking, so the words must NOT be red — that reads as an error. -->
    <ng-container *ngIf="warning.severity !== 'error'">
      <span class="warning-asterisk">*</span><span class="warning-prefix"> Suggested Change: </span>{{ warning.message }}
    </ng-container>
    <!-- Error: show plain message without prefix -->
    <ng-container *ngIf="warning.severity === 'error'">
      {{ warning.message }}
    </ng-container>
  </span>
</small>
